import { useEffect } from 'react'

/**
 * Sets the document title with a consistent prefix.
 * Pattern: "Page | DACcelerate"
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} | DACcelerate` : 'DACcelerate'
    return () => { document.title = 'DACcelerate' }
  }, [title])
}
